import { AxiosError } from "axios";
import { UseQueryOptions, useQuery } from "react-query";
import { IAgentState, IAgentStatesGetQueryParameters, Route } from "@edgetier/watchtower-types";
import { getAllPaginatedItems } from "utilities/get-all-paginated-items";

/**
 * Request all agent states
 * @param url  Route URL
 */
const getAgentStates = async (url: string, parameters: IAgentStatesGetQueryParameters) => {
    const states = await getAllPaginatedItems<IAgentState>(url, { params: parameters });
    return states;
};

/**
 * Get all agents states
 * @returns React Query result.
 */
export const useAgentStates = <T = IAgentState[]>(
    parameters: IAgentStatesGetQueryParameters = {},
    options: UseQueryOptions<IAgentState[], AxiosError<void>, T> = {}
) => {
    const url = Route.AgentStates;
    return useQuery<IAgentState[], AxiosError<void>, T>([url, parameters], () => getAgentStates(url, parameters), {
        cacheTime: 60 * 60 * 1000,
        ...options,
    });
};
